import Swiper from 'swiper/bundle';

function waitForImages(el) {
  const images = Array.from(el.querySelectorAll('img'));
  return Promise.all(
    images.map(img =>
      img.complete
        ? Promise.resolve()
        : new Promise(resolve => {
            img.addEventListener('load', resolve);
            img.addEventListener('error', resolve);
          })
    )
  );
}

export default Array.from(document.querySelectorAll('.logo-marquee')).map((marquee) => {
  const items = marquee.querySelector('.logo-marquee__items');
  if (!items) return null;
  
  waitForImages(items).then(() => {
    const originalContent = items.innerHTML;
    items.innerHTML = originalContent + originalContent + originalContent;
    const track = document.createElement('div');
    track.classList.add('logo-marquee__track');
    items.parentNode.insertBefore(track, items);
    track.appendChild(items);
    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper');
    track.parentNode.insertBefore(wrapper, track);
    wrapper.appendChild(track);
    items.classList.add('swiper-wrapper');
    Array.from(items.children).forEach(child => child.classList.add('swiper-slide'));
    const singleWidth = items.scrollWidth / 3;
    track.style.setProperty('--marquee-distance', `${singleWidth}px`);
    const speed = 50;
    const duration = singleWidth / speed;
    track.style.animationDuration = `${duration}s`;
    new Swiper(wrapper, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      allowTouchMove: false,
    });
  });
});
